import { apiRequest } from './http'
import type { PageResponse } from '@/types/common'
import type {
  CreateOrderRequest,
  CreateFundRequestRequest,
  Order,
  OrderResult,
  PortfolioSummary,
  Position,
  RechargeOrder,
  Wallet,
  WalletFundRequest,
  WalletLedger,
} from '@/types/trading'

export interface OrderQuery {
  page?: number
  size?: number
  side?: string
  status?: string
  symbol?: string
}

export const tradingApi = {
  listWallets() {
    return apiRequest<Wallet[]>({ method: 'GET', url: '/wallets' })
  },
  listWalletLedger(params: { page?: number; size?: number } = {}) {
    return apiRequest<PageResponse<WalletLedger>>({ method: 'GET', url: '/wallets/ledger', params })
  },
  listRecharges(params: { page?: number; size?: number } = {}) {
    return apiRequest<PageResponse<RechargeOrder>>({ method: 'GET', url: '/wallets/recharges', params })
  },
  listFundRequests(params: { page?: number; size?: number } = {}) {
    return apiRequest<PageResponse<WalletFundRequest>>({ method: 'GET', url: '/wallets/fund-requests', params })
  },
  createFundRequest(payload: CreateFundRequestRequest) {
    return apiRequest<WalletFundRequest>({ method: 'POST', url: '/wallets/fund-requests', data: payload })
  },
  listPositions() {
    return apiRequest<Position[]>({ method: 'GET', url: '/positions' })
  },
  getPortfolio() {
    return apiRequest<PortfolioSummary>({ method: 'GET', url: '/portfolio/summary' })
  },
  listOrders(params: OrderQuery = {}) {
    return apiRequest<PageResponse<Order>>({ method: 'GET', url: '/orders', params })
  },
  createOrder(payload: CreateOrderRequest, idempotencyKey: string) {
    return apiRequest<OrderResult>({
      method: 'POST',
      url: '/orders',
      data: payload,
      headers: { 'Idempotency-Key': idempotencyKey },
    })
  },
}
